/* ================================
   FC_QTY_LOCK_START
   TEMP: Disable quantity controls in Cart Drawer (Impulse)
   To revert: comment out this whole block.
================================== */
(function fcDisableCartDrawerQty() {
  const DRAWER_SELECTOR = '#CartDrawer, .drawer--cart'; // на всякий случай оба
  const LOCK_ATTR = 'data-fc-qty-locked';

  function lockInside(root) {
    if (!root || root.nodeType !== 1) return;

    // 1) Disable +/- buttons
    root.querySelectorAll('button.js-qty__adjust, button[data-quantity-plus], button[data-quantity-minus]').forEach((btn) => {
      // already processed
      if (btn.getAttribute(LOCK_ATTR) === '1') return;

      btn.setAttribute(LOCK_ATTR, '1');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');

      // чтобы вообще не кликалось
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.55';
      btn.style.cursor = 'not-allowed';
      btn.tabIndex = -1;
    });

    // 2) Disable number inputs (Impulse: input.js-qty__num name="updates[]")
    root.querySelectorAll('input.js-qty__num, input[name="updates[]"], input[id^="cart_updates_"]').forEach((inp) => {
      if (inp.getAttribute(LOCK_ATTR) === '1') return;

      inp.setAttribute(LOCK_ATTR, '1');
      inp.disabled = true;
      inp.setAttribute('aria-disabled', 'true');

      // чтобы не фокусилось/не редактировалось даже через UI-хаки
      inp.readOnly = true;
      inp.style.pointerEvents = 'none';
      inp.style.opacity = '0.75';
      inp.style.cursor = 'not-allowed';
      inp.tabIndex = -1;
    });

    // 3) Если где-то есть select для количества — тоже вырубаем
    root.querySelectorAll('select[name="updates[]"], select[id^="cart_updates_"]').forEach((sel) => {
      if (sel.getAttribute(LOCK_ATTR) === '1') return;

      sel.setAttribute(LOCK_ATTR, '1');
      sel.disabled = true;
      sel.setAttribute('aria-disabled', 'true');
      sel.style.pointerEvents = 'none';
      sel.style.opacity = '0.75';
      sel.style.cursor = 'not-allowed';
      sel.tabIndex = -1;
    });
  }

  function lockNow() {
    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;
    lockInside(drawer);
  }

  // старт сразу
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockNow);
  } else {
    lockNow();
  }

  // держим при любых апдейтах drawer
  const obs = new MutationObserver(() => lockNow());
  const startObs = () => {
    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;
    obs.observe(drawer, { childList: true, subtree: true });
  };

  // попытка сразу + повтор через небольшую задержку (Impulse иногда вставляет drawer позже)
  startObs();
  setTimeout(startObs, 600);

  // на события темы (на случай если drawer строится заново)
  ['cart:refresh', 'cart:updated', 'ajaxProduct:added', 'drawer:open', 'theme:cart:open'].forEach((evt) => {
    document.addEventListener(evt, () => setTimeout(lockNow, 50));
  });
})();
/* ================================
   FC_QTY_LOCK_END
================================== */